module.exports = __webpack_public_path__ + "img/ic_dashboard.abe47f40.png";